import { useRef } from 'react';
import { Box, Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { useSnack } from 'shared/ui/snack';
import { Heading } from 'shared/ui/list-page-heading';
import { useActionCreators, useStateSelector } from 'shared/store';

import { SalaryEntryForm } from 'entities/salary/salary-entry-dialog/salary-entry.form';
import { SalaryEntriesGrid } from 'entities/salary/salary-entries/salary-entries-grid';
import { SalaryCommissionGrid } from 'entities/salary/salary-entries/salary-commission-grid';
import { salaryDialogActions } from 'entities/salary/salary-entry-dialog/salary-entry.slice';
import { PrepaymentDto } from '@sr/dto';
import { PrepaymentDialogForm } from 'entities/salary/prepayment/prepayment-dialog/prepayment-dialog.form';
import { prepaymentDialogActions } from 'entities/salary/prepayment/prepayment-dialog/prepayment-dialog.slice';
import { fetchPrepayment } from 'entities/salary/prepayment/prepayment.api';
import { useSearchParams } from 'react-router-dom';
import { Payroll } from './payroll/payroll';

export const SalaryEntries = () => {
  const selectedPeriod = useStateSelector((state) => state.salaryPageSelectedPeriod.value);

  const prepaymentToEdit = useRef<PrepaymentDto | null>(null);
  const [searchParams] = useSearchParams();

  const { showError, showSuccess } = useSnack();
  const { openDialog } = useActionCreators(salaryDialogActions);
  const { openDialog: openPrepaymentDialog } = useActionCreators(prepaymentDialogActions);

  const managerValue = searchParams.get('manager');

  const handlePrepaymentAdd = () => {
    prepaymentToEdit.current = null;
    openPrepaymentDialog();
  };

  const handlePrepaymentEdit = (salaryEntryId: number) => {
    fetchPrepayment(salaryEntryId).then((p) => {
      prepaymentToEdit.current = p;
      openPrepaymentDialog();
    });
  };

  return (
    <>
      <Heading
        sx={{ mb: 2 }}
        title="Начисления/Удержания"
        actions={
          <Stack direction="row" spacing={1}>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => openDialog()} size={'small'}>
              Добавить запись
            </Button>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => handlePrepaymentAdd()} size={'small'}>
              Внести аванс
            </Button>
          </Stack>
        }
      />
      <SalaryEntryForm />

      <PrepaymentDialogForm prepayment={prepaymentToEdit} selectedPeriod={selectedPeriod} />

      {managerValue && !isNaN(Number(managerValue)) ? (
        <>
          <Payroll year={selectedPeriod.year} month={selectedPeriod.month} userId={Number(managerValue)} />
          <SalaryEntriesGrid year={selectedPeriod.year} month={selectedPeriod.month} userId={Number(managerValue)} onEditClick={handlePrepaymentEdit} />

          <Heading sx={{ mt: 3, mb: 2 }} title="Проценты" />
          <SalaryCommissionGrid year={selectedPeriod.year} month={selectedPeriod.month} userId={Number(managerValue)} />
        </>
      ) : (
        <Box sx={{ pt: 2 }}>Выберите менеджера для просмотра заработной платы</Box>
      )}
    </>
  );
};
